import { useEffect, useState } from "react";

const MOBILE_MAX = 768;

/** Même seuil que le Coffre. Le bureau ne passe pas par ce hook. */
export function useFxMobile(): boolean {
  const [mobile, setMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < MOBILE_MAX : false,
  );

  useEffect(() => {
    const on = () => setMobile(window.innerWidth < MOBILE_MAX);
    window.addEventListener("resize", on);
    on();
    return () => window.removeEventListener("resize", on);
  }, []);

  return mobile;
}
